import styled from 'styled-components';
import { CaptionRegularM } from '../../../../styles/globals';
import { IThemeProvider } from '../../../../styles/theme';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 17px;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[90]};
  `}
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0.8rem 0 4rem 0;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[5]};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    border-radius: ${theme.layout.spacing.mikro};
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.centy} 20px;
  `}
`;

export const DescriptionSegment = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Description = styled.div`
  letter-spacing: 0.07px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

export const ShowButton = styled(CaptionRegularM)`
  cursor: pointer;
  display: inline;
  text-decoration: underline;
  align-self: flex-start;
  padding: 0;
  margin: 0;
  ${({ theme }) => `
    color: ${theme.colors.support.blue[100]};
  `}
`;

export const TimestampsWrapper = styled.div`
  padding-top: 14px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
`;
